import { type QueryClient } from '@tanstack/react-query';

/**
 * Refetches everything that shows a source after something outside the
 * sources pages changed it (today, the agent's tools). Without it an open
 * setup form would save its stale values back over the change.
 */
export const invalidateSourceQueries = (
  queryClient: QueryClient,
  sourceId: string,
) =>
  Promise.all(
    [
      ['sources'],
      ['crawlConfig', sourceId],
      ['convertConfig', sourceId],
      ['crawlStatus', sourceId],
      ['previewPages', sourceId],
    ].map((queryKey) => queryClient.invalidateQueries({ queryKey })),
  );
